import React from 'react'

import Field from '@utilities/Field'
import FieldContainer from './FieldContainer'

class SelectField extends Field {
  displayName = 'SelectField'

  render() {
    const { autoComplete, field, name, info, icon, label, optional } = this.props

    return (
      <FieldContainer field={field} info={info} icon={icon} label={label} optional={optional}>
        <div className="Control">
          <select
            autoComplete={autoComplete}
            id={name}
            name={name}
            className="Select"
            value={field.value || ''}
            placeholder={this.props.placeholder}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
          >
            {this.props.children}
          </select>
        </div>
      </FieldContainer>
    )
  }
}

export default SelectField
